<template>
    <div class="detail-wrapper" v-if="detailData">
        <div class="detail-main">
            <div class="detail-img">
                <img :src="detailData.data.img + '?imageMogr2/thumbnail/600x'" alt="">
            </div> 
            <div class="detail-title-wrap">
                <div class="detail-vote-wrap">
                    <div class="detail-vote-inner">
                        <span class="vote-num">{{detailData.count}}</span>&nbsp;票
                    </div>                    
                </div>
                <p class="detail-title">
                    {{detailData.data.title}}
                </p>
            </div>
            <div class="detail-desc" v-html="detailData.data.desc"></div>
        </div>
        <div class="detail-page">
            <span class="back-btn" @click="backPage">返回上一页</span>
            <span class="vote-btn" @click="handleVote(detailData._id)">投票</span>
        </div>
        <dialog-component :dialogData="dialogData" v-if="dialogData" @setDialogDataEvent="setDialogData"></dialog-component>
        <base-component :baseData="baseData" v-if="baseData"></base-component>
    </div>
</template>

<script>

import BaseComponent from '@/components/Base'
import COVER from '@/utils/COVER'
import DialogComponent from '@/components/Dialog'
import COVERAPP from '@/utils/COVERAPP'

import { mapState, mapActions } from 'vuex'

export default {
    data() {
        return {
            dialogData: null,
            cid: '',
            vid: '',
            detailData: null
        }
    },
    props: ['baseData'],
    components: {
        DialogComponent,
        BaseComponent
    },
    computed: {
        ...mapState(['aid', 'userinfo'])
    },
    created() {
        this.cid = this.$route.query.id || ''
        this.vid = this.$route.query.vid || ''
        this.getDetail()
    },
    mounted() {
        if(!this.userinfo.token) {
            this.getUserInfon() 
        }       
    },
    methods: {
        ...mapActions([
            'getUserinfoAsync'
        ]),
        getUserInfon() {
            this.getUserinfoAsync(); 
        },
        setDialogData() {
            this.dialogData = null
        },
        getDetail() {
            COVER.$request('/vote/detail', {
                vid: this.vid,
            }).then((res)=> {
                this.detailData = res.data
            })
        },
        handleVote(id) {
            if(!this.userinfo.token) {
                this.dialogData = {
                    message: '参与活动，需登录!',
                    btns: [
                        {
                            text: '去登录',
                            className: 'login-btn'
                        },
                        {
                            text: '取消',
                            className: 'close-btn'
                        }
                    ]
                }
                return;
            }
            this.dialogData = {
                message: '投票中，请稍后...'
            }
            COVER.$request('/vote', {
                cid: this.cid,
                userid: this.userinfo.token,
                vid: id,
                userinfo: JSON.stringify(this.userinfo),
                aid: this.aid
            }).then((res) => {
                if(res.errno == 0) {
                    this.dialogData = {
                        message: '投票成功',
                        btns: [
                            {
                                text: '确认'
                            }
                        ]
                    }
                    this.detailData.count++;
                } else {
                    this.dialogData = {
                        message: res.errmsg || '投票失败，请重试',
                        btns: [
                            {
                                text: '确认'
                            }
                        ]
                    }
                }   
            })
        },
        backPage() {
            this.$router.push(`/list?id=${this.cid}`)
        }
    }
}
</script>

<style lang="less" scoped>
    .detail-img{
        width: 100%;
        overflow: hidden;
        background-color: #eaeaea;
        position: relative;
    }
    .video-btn{
        width: 100%;
        height: 100%;
        background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1c1uiks011tbds1u1djqbjj1vh6d.png) no-repeat center / 2rem auto;
        position: absolute;
        left: 0;
        top: 0;
    }
    .detail-title-wrap{
        background-color: #f4f3f9;
        overflow: hidden;
        min-height: 1.296296rem;
        position: relative;
    }
    .detail-vote-wrap{
        width: 3.703704rem;
        background-color: #e30504;
        font-size: .388889rem;
        color: #fff;
        float: left;
        margin: 0;
        text-align: center;
        position: absolute;
        left:0;
        top: 0;
        height: 100%;
    }
    .detail-vote-inner{
        font-weight:600;
        line-height: 1.3;
        position: relative;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .detail .vote-num{
        font-size: .555556rem;
    }
    .detail-title{
        font-size: .481481rem;
        color: #383838;
        font-weight: bold;
        padding: .37037rem .462963rem .37037rem 4.148148rem;
        box-sizing: border-box;
        margin: 0;    
    }
    .detail-title span{
        display: block;
        font-size: 0.3rem;
        padding-top: 0.1rem;
        line-height: 1.2;
        color: #666;
    }
    .detail-desc{
        font-size: .388889rem;
        color: #383838;
        padding: .601852rem .462963rem .601852rem .555556rem;
        line-height: 1.5;
    }
    .detail-page{
        letter-spacing: -4px;
        text-align: center;
        padding-bottom: 2rem;
    }
    .detail-page span{
        display: inline-block;
        width: 3.148148rem;
        margin:  0 .462963rem;
    }
    .back-btn{
        font-size: .444444rem;
        color: #e30504;
        box-sizing: border-box;
        border: 2px solid #e30504;
        height: 1.018519rem;
        border-radius: 0.8rem;
        font-weight: bold;
        letter-spacing: 0.03rem;
        padding: .22rem 0;
        text-align: center;
    }
    .vote-btn{
        font-size: .444444rem;
        color: #fff;
        font-weight: bold;
        width: 3.148148rem;
        height: 1.092593rem;
        border: 2px solid #f5df78;
        padding: 0.2rem 0;
        line-height: 1.3;
        text-align: center;
        background: #dc372f;
        border-radius: 0.8rem;
        margin: 0 auto;
        box-shadow: 0 .185185rem .462963rem #fac3c3;
        letter-spacing: 0.1rem;
        box-sizing: border-box;
    }
    .vote-btn.voted{
        color: #db332a;
        border: 2px solid #db332a;
        background: #fff;
    }
</style>
